import { Box, Link } from "@mui/material";
import NoData from "../ErrorMessage";
import { isLocalDev } from "../../theme";
import { buildBigQueryUrl } from "../../data/https";

// "No results" is ambiguous: the country genuinely has no data, or the query is wrong. When
// running locally, show the exact call behind it so the two can be told apart without
// digging through the network tab. Local only, deliberately: review is a deployed
// environment that reviewers look at, and raw SQL has no business being on screen there.
const QueryDebug = ({ query }) => {
    if (!isLocalDev || !query) return null;

    let sql = query;
    try {
        sql = decodeURIComponent(query);
    } catch {
        // Leave it encoded rather than losing the query to a malformed escape sequence.
    }

    return (
        <Box
            sx={(theme) => ({
                mt: 1.5,
                p: 1.5,
                border: `1px solid ${theme.palette.secondary.dark}`,
                borderRadius: "6px",
                fontSize: "11px",
            })}
        >
            <Box sx={{ fontWeight: 600, mb: 0.5 }}>Query (local development only)</Box>
            <Box
                component="pre"
                sx={{ m: 0, whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: "11px" }}
            >
                {sql}
            </Box>
            <Link
                href={buildBigQueryUrl(query)}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "inline-block", mt: 1, fontSize: "11px" }}
            >
                Run this call
            </Link>
        </Box>
    );
};

export default function ChartTabContent({
    noData,
    isPoU,
    header,
    footer,
    isFoodInsecurity,
    ChartComponent,
    query,
    data,
    showDataLabels,
    useLogScale,
    showSubregions,
    chartTitle,
    regions,
    info
}) {
    if (noData) {
        return (
            <Box className="no-results" sx={{ m: 2 }}>
                <NoData
                    severity="warning"
                    text="No results for this country in this range of dates."
                />
                <QueryDebug query={query} />
            </Box>
        );
    }

    return (
        <>
            {header != null && (
                <Box
                    sx={{
                        fontSize: "12.6px!important",
                        mb: 1,
                        mt: -2,
                    }}
                >
                    <NoData
                        severity="info"
                        text={header}
                    />
                </Box>
            )}
            <ChartComponent
                data={data}
                showDataLabels={showDataLabels}
                useLogScale={useLogScale}
                hideSubregions={showSubregions}
                title={chartTitle}
                regions={regions}
                chartStacked={info.chart_stack}
                seriesByYear={info.series_by_year}
                dualAxis={info.dual_axis}
            />
            {footer != null && (
                <Box
                    sx={{
                        fontSize: "12.6px!important",
                        mb: 0,
                        mt: 2,
                    }}
                >
                    <NoData
                        severity="info"
                        text={footer}
                    />
                </Box>
            )}
        </>
    );
}
